import { render, staticRenderFns } from "./edit-certificate.vue?vue&type=template&id=96f7001e&scoped=true&"
import script from "./edit-certificate.vue?vue&type=script&lang=js&"
export * from "./edit-certificate.vue?vue&type=script&lang=js&"
import style0 from "./edit-certificate.vue?vue&type=style&index=0&id=96f7001e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f7001e",
  null
  
)

export default component.exports